import endpoints from '../../API/endpoints'
import callFileAPI from '../../API/callFileAPI'
import { useAuth0 } from '../../contexts/auth0-context'
import { useQuery } from 'react-query'

const ONE_MINUTE = 1000 * 60
const FIVE_MINUTES = ONE_MINUTE * 5

export type StrategicAnchorFile = Blob

export const useGetStrategicAnchorFile = () => {
    const { getTokenSilently } = useAuth0()

    const getStrategicAnchorFile = async (roadmapId: string, anchorType: string, index: number) => {
        const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
        const { url, method } = endpoints.downloadAnyFile
        return await callFileAPI(`${url}${roadmapId}/${anchorType}/${index}`, method, token)
    }

    return { getStrategicAnchorFile }
}
